// removed by extract-text-webpack-plugin
module.exports = {"deleteItem":"XBF4Pwh"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/LineItem/DeleteItem/index.css
// module id = ./template/components/MiniBag/LineItem/DeleteItem/index.css
// module chunks = client.sitechrome